import { useEffect, FC, useState } from "react";
import { useQuery } from "react-query";
import axiosOrg, { AxiosError, AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import styled from "styled-components";

//MUI components
import Button from "@mui/material/Button";

//custom components
import IdleWatcher from "../../components/common/IdleWatcher/IdleWatcher.component";

//pages
import PageLogin from "./Login.page";

//utils
import axios from "../../utils/api";

// //hooks
import { useAuth, usePageError, useCategories } from "../../hooks/hooks";

const FailWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;

interface Props {}

const PageHome: FC<Props> = () => {
  const [appLoaded, setAppLoaded] = useState<boolean>(false);
  const [loadFailed, setLoadFailed] = useState<boolean>(false);
  const { setLanguages } = useAuth();
  const { setCategories } = useCategories();
  const { setRetryFn, setErrorMsg, setVisibleError } = usePageError();
  const { t, i18n } = useTranslation();
  const [languagesLoaded, setLanguagesLoaded] = useState<boolean>(false);

  const { refetch: getUser } = useQuery(
    "getUser",
    async () => {
      const data = await axios("user");
      return data;
    },
    {
      onSuccess: (data: AxiosResponse<any>) => {
        if (!axiosOrg.isAxiosError(data)) {
          // setUser({
          //   ...(data?.data?.user || {}),
          // });
        }
      },
      onError: (error: AxiosError) => {
        setLoadFailed(true);
      },
    }
  );

  const { refetch: getLanguages } = useQuery(
    "getLanguages",
    async (userId) => {
      const data = await axios("locales");
      return data;
    },
    {
      onSuccess: (data: AxiosResponse<any>) => {
        if (!axiosOrg.isAxiosError(data)) {
          const newLangs = Array.isArray(data?.data?.data) ? data?.data?.data : [];
          setLanguages(newLangs);
          //set first language as default
          i18n.changeLanguage(newLangs?.[0]?.code);
          setRetryFn({
            execute: () => getCategories(),
          });
          getCategories();
          setLanguagesLoaded(true);
        }
      },
      onError: (e: AxiosError<any>) => {
        // setRetryFn({
        //   execute: () => getLanguages(),
        // });
        // setLoadFailed(true);
        // setErrorMsg(e.response?.data?.message || `${t("pages.login.loginError")}`);
        // setVisibleError(true);
      },
    }
  );

  const { refetch: getCategories } = useQuery(
    "getCategories",
    async () => {
      const data = await axios("categories?sort=order&include=image", {
        headers: {
          "Accept-Language": i18n.language,
        },
      });
      return data;
    },
    {
      onSuccess: (data: AxiosResponse<any>) => {
        if (!axiosOrg.isAxiosError(data)) {
          setCategories(data?.data?.data || []);
          setAppLoaded(true);
        }
      },
      onError: (e: AxiosError<any>) => {
        setRetryFn({
          execute: () => getCategories(),
        });
        setLoadFailed(true);
        setErrorMsg(e.response?.data?.message || `${t("pages.login.loginError")}`);
        setVisibleError(true);
      },
    }
  );

  useEffect(() => {
    getLanguages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (languagesLoaded) {
      getCategories();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  // return loadFailed ? <PageLogin /> : appLoaded ? <Outlet /> : null;
  return (
    <>
      {loadFailed ? (
        <FailWrapper>
          <span>Възникна грешка при зареждане</span>
          <Button
            variant="outlined"
            color="primary"
            type="submit"
            size="large"
            onClick={() => {
              window.location.reload();
            }}
          >
            Reload
          </Button>
        </FailWrapper>
      ) : appLoaded ? (
        <Outlet />
      ) : null}
      <IdleWatcher />
    </>
  );
};

export default PageHome;
